import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VeeValidate from 'vee-validate'
import VueValidationEs from 'vee-validate/dist/locale/es'
import VueResource from 'vue-resource'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import 'v-slim-dialog/dist/v-slim-dialog.css'
import SlimDialog from 'v-slim-dialog'

import VuePaginate from 'vue-paginate'
import store from './store'

Vue.use(VueResource);
Vue.use(Loading);
Vue.use(SlimDialog);
Vue.use(VuePaginate);

Vue.use(VeeValidate, {
    events: 'change|blur',
    locale: 'es',
    dictionary: {
        'es': VueValidationEs
    }
});

Vue.config.productionTip = false

Vue.prototype.$api = process.env.VUE_APP_API;

new Vue({
    loginStatus: true,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
